import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Menu, MenuItem } from "@material-ui/core";
import { ArrowDropDown } from "@material-ui/icons";
import { Button, SortIconDesc, SortIconAsce } from "./Common";

const CustomButton = styled(Button)`
  border: none;
  position: relative;
  padding: 0;
`;

export class SortComp extends PureComponent {
  state = {
    anchorEl: null,
    selected: "createdAt",
    orderBy: false,
    sortByOrder: "desc",
    selectedSortBy: "Recently Created"
  };

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleBackDropClick = () => {
    this.setState({ anchorEl: null });
  };

  changeOrder = () => {
    const { changeSortOrder, onChange } = this.props;
    const { orderBy, selected } = this.state;
    this.setState(
      { orderBy: !orderBy, sortByOrder: !orderBy ? "asc" : "desc" },
      () => {
        // eslint-disable-next-line no-shadow
        const { sortByOrder } = this.state;
        changeSortOrder(sortByOrder);
        onChange(selected, sortByOrder);
      }
    );
  };

  handleClose = (value, sortBy, label) => {
    const { onChange } = this.props;
    const newOrderBy = sortBy !== "desc";
    this.setState(
      {
        orderBy: newOrderBy,
        anchorEl: null,
        selected: value,
        sortByOrder: sortBy,
        selectedSortBy: label
      },
      () => {
        // eslint-disable-next-line no-shadow
        const { selected, sortByOrder } = this.state;
        onChange(selected, sortByOrder);
      }
    );
  };

  render() {
    const { className, options } = this.props;
    const {
      anchorEl,
      selected,
      sortByOrder,
      orderBy,
      selectedSortBy
    } = this.state;
    return (
      <div className={className}>
        <div className="sort-button">
          <CustomButton className="order-by-btn" onClick={this.changeOrder}>
            {orderBy === false && sortByOrder === "desc" ? (
              <SortIconDesc className="sort-icon" />
            ) : (
              <SortIconAsce className="sort-icon" />
            )}
          </CustomButton>
          <CustomButton className="sort-option-btn" onClick={this.handleClick}>
            {selectedSortBy || "Sort By"}
            <span className="dropdown-arrow">
              <ArrowDropDown />
            </span>
          </CustomButton>
        </div>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleBackDropClick}
        >
          {options.map(({ label, value, sortBy }) => (
            <MenuItem
              key={value}
              selected={selected === value}
              onClick={() => this.handleClose(value, sortBy, label)}
            >
              {label}
            </MenuItem>
          ))}
        </Menu>
      </div>
    );
  }
}

SortComp.propTypes = {
  className: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  onChange: PropTypes.func,
  changeSortOrder: PropTypes.func
};

SortComp.defaultProps = {
  className: "",
  options: [],
  onChange: () => {},
  changeSortOrder: () => {}
};

export const Sort = styled(SortComp)`
  .dropdown-arrow {
    position: absolute;
    right: 3px;
    height: 14px;
    top: -3px;
  }
  .sort-button {
    position: relative;
    border: solid 1px ${({ theme }) => theme.palette.LIGHTGREY4};
    padding: 5px 0 5px 15px;
    font-family: ${({ theme }) => theme.fontFamily.BOLD};
    font-size: ${({ theme }) => theme.fontSize.MEDIUM};
    border-radius: 4px;
    color: ${({ theme }) => theme.palette.DARKGREY3};
    background: ${({ theme }) => theme.palette.WHITE};
    display: flex;
    align-items: center;
    position: relative;
    .sort-option-btn {
      padding-right: 30px;
      white-space: nowrap;
    }
  }
  .order-by-btn {
    border-right: solid 1px ${({ theme }) => theme.palette.MEDIUM_GREY};
    border-radius: 0;
    margin-right: 10px;
  }
  .sort-icon {
    margin-right: 10px;
  }
`;
